/**
 * @description This is a copy from ElementUI Notification component located at
 * node_modules/element-ui/packages/notification/src/main.js
 *
 * This was needed due to impossibility of using inject-loader package
 * with new vue-loader version - https://github.com/vuejs/vue-cli/issues/947
 */

import Vue from 'vue'
import Main from '@/components/global/dd-notification.vue'
import { PopupManager } from 'element-ui/src/utils/popup'
import { isVNode } from 'element-ui/src/utils/vdom'
import { ElNotification } from 'element-ui/types/notification'
const NotificationConstructor = Vue.extend(Main)

let instance
const instances = [] as any
let seed = 1

const DdNotification = (options: any) => {
  if (Vue.prototype.$isServer) {
    return
  }
  options = options || {}
  const userOnClose = options.onClose
  const id = 'notification_' + seed++
  const position = options.position || 'top-right'

  options.onClose = () => {
    // @ts-ignore
    DdNotification.close(id, userOnClose)
  }

  instance = new NotificationConstructor({
    data: options,
  })

  if (isVNode(options.message)) {
    instance.$slots.default = [options.message]
    options.message = 'REPLACED_BY_VNODE'
  }
  instance.id = id
  instance.$mount()
  document.body.appendChild(instance.$el)
  instance.visible = true
  instance.dom = instance.$el
  instance.dom.style.zIndex = PopupManager.nextZIndex()

  let verticalOffset = options.offset || 0
  instances
    .filter((item: any) => item.position === position)
    .forEach((item: any) => {
      verticalOffset += item.$el.offsetHeight + 16
    })
  verticalOffset += 16
  instance.verticalOffset = verticalOffset
  instances.push(instance)
  return instance
}
;['success', 'warning', 'info', 'error'].forEach(type => {
  // @ts-ignore
  DdNotification[type] = (options: any) => {
    if (typeof options === 'string' || isVNode(options)) {
      options = {
        message: options,
      }
    }
    options.type = type
    return DdNotification(options)
  }
})
// @ts-ignore
DdNotification.close = (id: any, userOnClose: any) => {
  let index = -1
  const len = instances.length
  const instance = instances.filter((inst: any, i: any) => {
    if (inst.id === id) {
      index = i
      return true
    }
    return false
  })[0]
  if (!instance) {
    return
  }

  if (typeof userOnClose === 'function') {
    userOnClose(instance)
  }
  instances.splice(index, 1)

  if (len <= 1) {
    return
  }
  const position = instance.position
  const removedHeight = instance.dom.offsetHeight
  for (let i = index; i < len - 1; i++) {
    if (instances[i].position === position) {
      instances[i].dom.style[instance.verticalProperty] =
        parseInt(instances[i].dom.style[instance.verticalProperty], 10) -
        removedHeight -
        16 +
        'px'
    }
  }
}
// @ts-ignore
DdNotification.closeAll = () => {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].close()
  }
}

Vue.prototype.$ddnotify = DdNotification

export default DdNotification

declare module 'vue/types/vue' {
  export interface Vue {
    $ddnotify: ElNotification
  }
}
